import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/core/auth/AuthContext';
import { integrationsService } from '../services/integrations.service';

export function useIntegrations() {
  const { profile } = useAuth();
  const companyId = profile?.company_id || '';
  const [querySearch, setQuerySearch] = useState('');

  const query = useQuery({
    queryKey: ['settings1', 'integrations', 'list', companyId],
    queryFn: () => integrationsService.getIntegrations(companyId),
    enabled: !!companyId,
  });

  const integrations = useMemo(() => {
    const search = querySearch.toLowerCase().trim();
    return (query.data || []).filter(i => 
      !search || i.name.toLowerCase().includes(search) || i.category.toLowerCase().includes(search)
    );
  }, [query.data, querySearch]);

  return {
    integrations,
    querySearch,
    isLoading: query.isLoading,
    setQuerySearch,
    refetch: query.refetch,
  };
}
